import React from 'react'
import { useNavigate } from 'react-router-dom';
import { leftIcon } from '../../../assets';

const BackArrowButton = ({className =""}) => {
    const navigate = useNavigate();
  return (
    <div className="flex justify-start">
    <button
      className={`px-2 py-2 h-10 w-14 rounded-sm flex items-center ${className}`}
      onClick={() => navigate(-1)}
    >
      <img src={leftIcon} alt="" className='h-8 w-8'/>
    </button>
  </div>
  )
}

export default BackArrowButton